import React from "react";

export default function Toolbar({
  loading,
  error,
  isSingle,
  listResults,
  onRefresh,
  onExport,
}) {
  return (
    <div className="spd__toolbar">
      <button className="spd__btn spd__btn--primary" onClick={onRefresh}>
        🔄 Refresh
      </button>

      {!isSingle && listResults?.length > 0 && (
        <button className="spd__btn spd__btn--ghost" onClick={onExport}>
          ⬇️ Export CSV
        </button>
      )}

      {loading && <span className="spd__hint">Loading…</span>}
      {error && <span className="spd__error">{error}</span>}
    </div>
  );
}
